import { render, staticRenderFns } from "./SpreadViewerContentOptions.vue?vue&type=template&id=3b17c2ac"
import script from "./SpreadViewerContentOptions.vue?vue&type=script&lang=js"
export * from "./SpreadViewerContentOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b17c2ac')) {
      api.createRecord('3b17c2ac', component.options)
    } else {
      api.reload('3b17c2ac', component.options)
    }
    module.hot.accept("./SpreadViewerContentOptions.vue?vue&type=template&id=3b17c2ac", function () {
      api.rerender('3b17c2ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/spread-viewer-options/SpreadViewerContentOptions.vue"
export default component.exports